import { getLocales } from 'expo-localization';

import { createI18n } from '@/i18n/i18n';

const deviceLanguage = getLocales()[0]?.languageCode ?? 'en';

const i18n = createI18n(deviceLanguage);

export { i18n };
